// extracted by css-extract-rspack-plugin
export default {"toast":"kzCNag","btnClose":"m4gXZI"};